/**
 * @module app.cd
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { openProviderLocationSummary } from 'app/cd/components/summary/provider/provider-summary';
import * as CD from 'app/cd/models/essette-api';


@autoinject()
export class ProviderLocationDisplayCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ defaultBindingMode: bindingMode.toView })
    public providerLocation: CD.ProviderLocation | null = null;
    @bindable.boolean({ defaultBindingMode: bindingMode.oneTime })
    public showIdentifier: boolean = false;
    @bindable.boolean({ defaultBindingMode: bindingMode.oneTime })
    public showTooltip: boolean = false;

    protected showProviderSummaryLink: boolean = false;
    protected openProviderLocationSummary = openProviderLocationSummary;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;

        this.checkPermissions();
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();

        this.showProviderSummaryLink = this.accountContext.hasRouteAccess('cd.provider.summary');
    }

    ////****************** Service Calls ********************************************////

}
